import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';
import styles from './styles.module.scss';

import NewTab from 'shared_features/svgs/new_tab';
import CreateOrganizationModal from 'shared_features/create_organization_modal';

class View extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isCreateOrgModalOpen: false,
            isMobileMenuOpen: false,
            isAccountMenuOpen: false
        };
        this.accountRef = React.createRef();
        this.mobileMenuRef = React.createRef();
        this.hamburgerRef = React.createRef();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps !== this.props || nextState !== this.state;
    }

    toggleMobileMenu = () => {
        this.setState(prev => ({
            isMobileMenuOpen: !prev.isMobileMenuOpen,
            isAccountMenuOpen: false
        }));
    }

    closeMobileMenu = () => {
        this.setState({ isMobileMenuOpen: false });
    }

    toggleAccountMenu = () => {
        this.setState(prev => ({
            isAccountMenuOpen: !prev.isAccountMenuOpen,
            isMobileMenuOpen: false
        }));
    }

    closeAccountMenu = () => {
        this.setState({ isAccountMenuOpen: false });
    }

    handleClickOutside = (event) => {
        if (this.accountRef.current && !this.accountRef.current.contains(event.target)) {
            this.closeAccountMenu();
        }
        if (
            this.mobileMenuRef.current &&
            !this.mobileMenuRef.current.contains(event.target) &&
            this.hamburgerRef.current &&
            !this.hamburgerRef.current.contains(event.target)
        ) {
            this.closeMobileMenu();
        }
    }

    componentDidMount() {
        this.props.fetchAccount();
        this.props.fetchAccountOrganizations();
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleOpenCreateOrgModal = () => {
        this.setState({ isCreateOrgModalOpen: true });
    }

    handleCloseCreateOrgModal = () => {
        this.setState({ isCreateOrgModalOpen: false });
    }

    render() {
        const { isMobileMenuOpen } = this.state;
        const rosterTitle = this.props.isPersonal ? 'PROFILE' : 'ROSTER';

        return (
            <div className={styles.navWrapper}>
            <div className={styles.navBackground}>
                <div className={styles.nav}>
                    <img className={styles.logo} src={this.props.logoURL} alt="logo" />

                    {/* Desktop nav links */}
                    <div className={styles.desktopNav}>
                        <NavLink
                            to="/athletes"
                            className={styles.inactive}
                            activeClassName={styles.active}
                            isActive={(match, location)=> {
                                if (match) { return true; }
                                if (location && location.pathname && location.pathname.includes('teams')) { return true; }
                                return false;
                            }}>
                            <div>{rosterTitle}</div>
                        </NavLink>
                        <NavLink to="/programs" className={styles.inactive} activeClassName={styles.active}><div>PROGRAMS</div></NavLink>
                        <NavLink to="/reports" className={styles.inactive} activeClassName={styles.active}><div>REPORTS</div></NavLink>
                        <NavLink to="/live" target="_blank" className={styles.inactive} activeClassName={styles.active}><div>LIVE <NewTab /></div></NavLink>
                    </div>

                    {/* Mobile hamburger button */}
                    <button
                        ref={this.hamburgerRef}
                        className={styles.hamburger}
                        onClick={this.toggleMobileMenu}
                        aria-label="Toggle menu"
                    >
                        <span className={`${styles.hamburgerLine} ${isMobileMenuOpen ? styles.hamburgerLineOpen : ''}`}></span>
                        <span className={`${styles.hamburgerLine} ${isMobileMenuOpen ? styles.hamburgerLineOpen : ''}`}></span>
                        <span className={`${styles.hamburgerLine} ${isMobileMenuOpen ? styles.hamburgerLineOpen : ''}`}></span>
                    </button>

                    <div className={styles.account} ref={this.accountRef}>
                        <div className={styles.email} onClick={this.toggleAccountMenu}>
                            {this.props.organizationLogoURL && (
                                <img
                                    className={styles.orgLogo}
                                    src={this.props.organizationLogoURL}
                                    alt={this.props.organizationName}
                                />
                            )}
                            {this.props.organizationName}
                            <span className={`${styles.arrow} ${this.state.isAccountMenuOpen ? styles.arrowOpen : ''}`}>▼</span>
                        </div>
                        <div className={`${styles.menu} ${this.state.isAccountMenuOpen ? styles.menuOpen : ''}`}>
                            <div className={styles.userInfo}>
                                {this.props.email}
                            </div>
                            {this.props.availableOrganizations && this.props.availableOrganizations.length > 1 && (
                                <>
                                    <hr className={styles.divider} />
                                    {this.props.availableOrganizations
                                        .filter(orgRole => orgRole.org_id !== this.props.currentOrganization?.org_id)
                                        .map(orgRole => (
                                        <div
                                            key={orgRole.org_id}
                                            className={styles.orgOption}
                                            onClick={() => { this.props.switchOrganization(orgRole.org_id); this.closeAccountMenu(); }}
                                        >
                                            <span className={styles.orgName}>
                                                {orgRole.organization.name}
                                            </span>
                                            <button
                                                className={styles.switchButton}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    this.props.switchOrganization(orgRole.org_id);
                                                    this.closeAccountMenu();
                                                }}
                                            >
                                                Switch
                                            </button>
                                        </div>
                                    ))}
                                </>
                            )}
                            <hr className={styles.divider} />
                            <div
                                className={styles.createOrgButton}
                                onClick={() => { this.handleOpenCreateOrgModal(); this.closeAccountMenu(); }}
                            >
                                Create An Organization
                            </div>
                            <hr className={styles.divider} />
                            <NavLink to="/settings" className={styles.inactive} activeClassName={styles.active} onClick={this.closeAccountMenu}>Settings</NavLink>
                            <div onClick={() => { this.props.signOut(); this.closeAccountMenu(); }}>Logout</div>
                        </div>
                    </div>
                </div>
                {/* Mobile menu dropdown */}
                {isMobileMenuOpen && (
                    <div ref={this.mobileMenuRef} className={styles.mobileMenu}>
                        <NavLink
                            to="/athletes"
                            className={styles.mobileNavLink}
                            onClick={this.closeMobileMenu}
                            isActive={(match, location)=> {
                                if (match) { return true; }
                                if (location && location.pathname && location.pathname.includes('teams')) { return true; }
                                return false;
                            }}>
                            {rosterTitle}
                        </NavLink>
                        <NavLink to="/programs" className={styles.mobileNavLink} onClick={this.closeMobileMenu}>PROGRAMS</NavLink>
                        <NavLink to="/reports" className={styles.mobileNavLink} onClick={this.closeMobileMenu}>REPORTS</NavLink>
                        <NavLink to="/live" target="_blank" className={styles.mobileNavLink} onClick={this.closeMobileMenu}>LIVE <NewTab /></NavLink>
                        <NavLink to="/settings" className={styles.mobileNavLink} onClick={this.closeMobileMenu}>SETTINGS</NavLink>
                        <div className={styles.mobileNavLink} onClick={() => { this.closeMobileMenu(); this.props.signOut(); }}>LOGOUT</div>
                    </div>
                )}

                <CreateOrganizationModal
                    isOpen={this.state.isCreateOrgModalOpen}
                    onClose={this.handleCloseCreateOrgModal}
                />
            </div>
            </div>
        );
    }

}

export default View;
